import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { XmlHttpRequestHelper } from '@shared/helpers/XmlHttpRequestHelper';
import { LocalStorageService } from '@shared/utils/local-storage.service';
import { IAjaxResponse } from 'abp-ng2-module';

@Injectable()
export class AppAuthService {
    logout(reload?: boolean, returnUrl?: string): void {
        let customHeaders = {
            [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
            'Authorization': 'Bearer ' + abp.auth.getToken()
        };

        XmlHttpRequestHelper.ajax(
            'GET',
            AppConsts.remoteServiceBaseUrl + '/api/TokenAuth/B2CLogout',
            customHeaders,
            null,
            (ret: IAjaxResponse) => {
                this.logoutInternal(reload, returnUrl, ret);

                // abp.auth.clearToken();
                // abp.auth.clearRefreshToken();
                // new LocalStorageService().removeItem(AppConsts.authorization.encrptedAuthTokenName, () => {
                //     const btcUrl = ret.result;
                //     location.href = `${btcUrl}?post_logout_redirect_uri=${returnUrl ?? window.location.origin}`;
                // });
            },
            (errorResult: IAjaxResponse) => {
                if (errorResult.unAuthorizedRequest) {
                    abp.log.error(errorResult.error);
                    this.logoutInternal(reload, returnUrl);
                } else {
                    abp.message.error(errorResult.error.message);
                }
            },
            true
        );
    }

    logoutInternal(reload?: boolean, returnUrl?: string, returnData?: IAjaxResponse): void {
        abp.auth.clearToken();
        abp.auth.clearRefreshToken();
        new LocalStorageService().removeItem(AppConsts.authorization.encrptedAuthTokenName, () => {
            if (reload !== false) {
                if (returnData) {
                    const btcUrl = returnData.result;
                    location.href = `${btcUrl}?post_logout_redirect_uri=${returnUrl ?? window.location.origin}`;
                } else {
                    location.href = '';
                }
            }
        });
    }
}
